import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'langchain-text-splitter',
  version: '1.0.0',
  properties: [
    {
      key: 'splitterType',
      label: 'Splitter Type',
      type: 'options',
      required: true,
      default: 'recursive',
      options: [
        { value: 'recursive', name: 'Recursive Character' },
        { value: 'character', name: 'Character' },
        { value: 'token', name: 'Token' },
      ],
    },
    {
      key: 'chunkSize',
      label: 'Chunk Size',
      type: 'number',
      required: true,
      default: 1000,
      typeOptions: {
        minValue: 1,
        maxValue: 10000,
      },
    },
    {
      key: 'chunkOverlap',
      label: 'Chunk Overlap',
      type: 'number',
      default: 200,
      typeOptions: {
        minValue: 0,
        maxValue: 1000,
      },
    },
  ],
};

export default schema;
